module.exports = __webpack_public_path__ + "static/card-image-509c63ac1b98b011cfd012a808614a5e.jpg";